import i18n from '@/utils/i18n';
import OrderGuideIcon from '@assets/icons/order-guide.svg';
import React from 'react';
import { Analytics } from '@/utils/analytics';
import { BORDER } from '@/styles';
import { createStyles } from '@/contexts/theme-context';
import {
  EditOrderGuideActions,
  Partition,
} from '@/hooks/use-edit-order-guide-reducer';
import {
  ItemListOption,
  ItemListOptionMetadata,
} from '@/contexts/item-context-types';
import { ItemSubtitleV2 } from '@/components/item-subtitle-v2';
import { NO_PARTITION_NAME } from '@/contexts/multi-order-guide-items-context-provider';
import { TouchableOpacity, View } from 'react-native';
import { Type } from '@/components/toast';
import { useEditOrderGuideActions } from '@/contexts/edit-order-guide-context';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  itemUUID: string;
  option: ItemListOption;
  partition: Partition;
  sku: ItemListOptionMetadata;
}

export const AddPartitionItemsListItem: React.FC<Props> = ({
  itemUUID,
  option,
  partition,
  sku,
}) => {
  const dispatch = useEditOrderGuideActions();
  const { showToast } = useToasts();
  const [styles, theme] = useStyles();

  return (
    <TouchableOpacity
      onPress={() => {
        Analytics.track('edit_order_guide.order_guide_button.press', {
          itemUUID,
          partitionUUID: partition.partitionUUID,
          variantPackUUID: sku.variantPackUUID,
        });

        if (itemUUID) {
          dispatch({
            payload: {
              itemUUIDs: [itemUUID],
              partitionUUID: partition.partitionUUID,
            },
            type: EditOrderGuideActions.REMOVE_ITEMS,
          });
          showToast({
            content: i18n.t('toast.removed_from_group', {
              groupName: partition.partitionName || NO_PARTITION_NAME,
              itemName: option.title,
            }),
            type: Type.POSITIVE,
          });
        } else {
          dispatch({
            payload: {
              itemListOption: {
                ...option,
                metadata: sku,
                value: sku.variantPackUUID,
              },
              partitionUUID: partition.partitionUUID,
            },
            type: EditOrderGuideActions.ADD_ITEM,
          });
          showToast({
            content: i18n.t('toast.added_to_group', {
              groupName: partition.partitionName || NO_PARTITION_NAME,
              itemName: option.title,
            }),
            type: Type.POSITIVE,
          });
        }
      }}
      testID="list-item-button"
    >
      <View style={styles.itemSubtitleWrapper}>
        <View style={styles.itemSubtitleContainer}>
          <OrderGuideIcon
            fill={itemUUID ? theme.colors.accent : theme.colors.background}
            style={styles.orderGuideIcon}
          />
          <ItemSubtitleV2
            currencyCode={sku.currencyCode}
            displayString={sku.packDisplayString}
            sku={sku.externalID}
            unitCount={sku.unitCount}
          />
        </View>
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles(() => ({
  itemSubtitleContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  itemSubtitleWrapper: {
    ...BORDER.primary,
    gap: 8,
    marginVertical: 8,
    padding: 8,
  },
  orderGuideIcon: {
    height: 25,
    width: 25,
  },
}));
